import { put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';
import AnalyticsClient from '../../analytics/analyticsClient';
import trackEvents from '../../analytics/trackEvents';
import { selectToken } from '../selectors';

export function* getDataSourcesRequestSaga() {
  try {
    const res = yield send({
      url: `/data-status`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getDataSourcesRequestSuccess(res));
  } catch (error) {
    yield put(actions.getDataSourcesRequestFailure(error));
  }
}

export function* updateDataSourcesRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/data-status`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.updateDataSourcesRequestSuccess(res));
    AnalyticsClient.track(trackEvents.DATA_SOURCES_UPDATE);
  } catch (error) {
    yield put(actions.updateDataSourcesRequestFailure(error));
  }
}
